var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "thanksModal",
            "data-focus": "false",
            "data-keyboard": "false",
            "data-backdrop": "static",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-scrollable" },
            [
              _c("ValidationObserver", {
                ref: "letter",
                staticClass: "modal-content",
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ handleSubmit, reset }) {
                      return [
                        _c("div", { staticClass: "letter-modal" }, [
                          _c("div", { staticClass: "note-wrap" }, [
                            _c("div", { staticClass: "letter-title" }, [
                              _vm._v("感謝函"),
                            ]),
                            _c("div", { staticClass: "note-title" }, [
                              _vm._v("可動態套入信件內容，請參考以下參數"),
                            ]),
                            _c("div", { staticClass: "note-table" }, [
                              _vm.mailParameters
                                ? _c(
                                    "table",
                                    _vm._l(
                                      _vm.mailParameters,
                                      function (parameter, index) {
                                        return _c("tr", { key: index }, [
                                          _c("th", [
                                            _vm._v(
                                              _vm._s(
                                                parameter.MailParameterName
                                              )
                                            ),
                                          ]),
                                          _c("td", [
                                            _c("span", [_vm._v(" {{")]),
                                            _vm._v(
                                              _vm._s(
                                                parameter.MailParameterCode
                                              )
                                            ),
                                            _c("span", [_vm._v("}} ")]),
                                          ]),
                                        ])
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                          _c(
                            "form",
                            {
                              on: {
                                reset: function ($event) {
                                  $event.preventDefault()
                                  return reset.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "modal-content border-0" },
                                [
                                  _c(
                                    "perfect-scrollbar",
                                    { staticClass: "modal-body" },
                                    [
                                      _vm.mail.Name
                                        ? _c(
                                            "div",
                                            { staticClass: "form-group" },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "exampleInputEmail1",
                                                  },
                                                },
                                                [_vm._v("姓名：")]
                                              ),
                                              _c("span", [
                                                _vm._v(_vm._s(_vm.mail.Name)),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c("div", { staticClass: "form-group" }, [
                                        _c(
                                          "label",
                                          {
                                            attrs: {
                                              for: "exampleInputEmail1",
                                            },
                                          },
                                          [_vm._v("應徵職務：")]
                                        ),
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.mail.Position)),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v(" 信件範本： "),
                                        ]),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.selectedTemplateGuid,
                                                expression:
                                                  "selectedTemplateGuid",
                                              },
                                            ],
                                            staticClass: "form-control w-100",
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.selectedTemplateGuid =
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                },
                                                _vm.getMailTemplateDetail,
                                              ],
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: { disabled: "" },
                                                domProps: { value: null },
                                              },
                                              [_vm._v("請選擇")]
                                            ),
                                            _vm._l(
                                              _vm.mailTemplates,
                                              function (template) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: template.MailTemplateGuid,
                                                    domProps: {
                                                      value:
                                                        template.MailTemplateGuid,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          template.MailTemplateName
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              rules: "required",
                                              name: "信件主旨",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c(
                                                        "label",
                                                        { attrs: { for: "" } },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "mark",
                                                            },
                                                            [_vm._v("*")]
                                                          ),
                                                          _vm._v("信件主旨： "),
                                                        ]
                                                      ),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.mail
                                                                .MailSubject,
                                                            expression:
                                                              "mail.MailSubject",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control w-100",
                                                        attrs: {
                                                          placeholder:
                                                            "請輸入信件主旨或選擇範本",
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.mail
                                                              .MailSubject,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              _vm.mail,
                                                              "MailSubject",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                          staticStyle: {
                                                            "font-size": "13px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              rules: "required",
                                              name: "信件內容",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c(
                                                        "label",
                                                        { attrs: { for: "" } },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "mark",
                                                            },
                                                            [_vm._v("*")]
                                                          ),
                                                          _vm._v("信件內容： "),
                                                        ]
                                                      ),
                                                      _c("VueEditor", {
                                                        staticStyle: {
                                                          background:
                                                            "rgb(255, 255, 255)",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.mail
                                                              .MailTemplateBody,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.mail,
                                                              "MailTemplateBody",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "mail.MailTemplateBody",
                                                        },
                                                      }),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                          staticStyle: {
                                                            "font-size": "13px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c("div", { staticClass: "modal-footer" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-secondary",
                                        attrs: {
                                          type: "reset",
                                          "aria-label": "關閉",
                                        },
                                        on: { click: _vm.closeThanksMailModal },
                                      },
                                      [_vm._v(" 取消 ")]
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return handleSubmit(_vm.preview)
                                          },
                                        },
                                      },
                                      [_vm._v(" 預覽 ")]
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-success",
                                        attrs: {
                                          type: "button",
                                          disabled: _vm.clickDisabled,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return handleSubmit(_vm.thanksMail)
                                          },
                                        },
                                      },
                                      [_vm._v(" 寄出 ")]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
      _c("PreviewMailModal", { attrs: { type: "thanks", mail: _vm.mail } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }